import { InfoBar } from '../InfoBar/InfoBar';

export const TripInfoBar = ({
  url,
  catchesCount,
  className = '',
}: {
  url: string;
  catchesCount: number;
  className?: string;
}) => {
  return (
    <InfoBar linkUrl={url} linkText="View trip" className={className}>
      Part of a trip with <b>{catchesCount}</b> catch{catchesCount > 1 ? 'es' : ''}
    </InfoBar>
  );
};
